import React from 'react';
import { SvgIconProps } from '@mui/material';

export const ReportsIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="28"
        height="36"
        viewBox="0 0 28 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.57143 19.8889H17.7143M6.57143 27.4444H21.4286M15.8571 1H1V4.77778V35H27V25.5556M15.8571 1H17.7143L27 10.4444V12.3333M15.8571 1V8.55556C15.8571 10.4444 17.7143 12.3333 19.5714 12.3333H27M27 12.3333V18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ReportsIcon;
